import Vue from "vue";
import { apiConstants } from "../../config";
import { apiPost } from "../../../../shared/services";
import { apiPut } from "../../../../shared/services/api-requests/api-put";

const fetchUsers = options => {
  const url = apiConstants.users;
  return Vue.axios.get(url, { params: options }).then(res => res.data);
};

const fetchRoles = options => {
  const url = apiConstants.roles;
  return Vue.axios.get(url, { params: options }).then(res => res.data);
};

const fetchCompanies = options => {
  const url = apiConstants.companies;
  return Vue.axios.get(url, { params: options }).then(res => res.data);
};

const saveUser = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.users + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.users;
    return await apiPost(url, { ...data }, validator);
  }
};

const fetchUser = async id => {
  const url = apiConstants.users;
  return Vue.axios.get(url + "/" + id).then(res => res.data);
};

const deleteUser = async id => {
  const url = apiConstants.users;
  return await Vue.axios.delete(url + "/" + id);
};

export {
  fetchUsers,
  fetchRoles,
  saveUser,
  deleteUser,
  fetchUser,
  fetchCompanies
};
